function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAidaCardImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.08,204.63c.86-6.25-8-11.4-14.6-11.93-3.16-.26-6.45.23-9.45-.82-6.49-2.26-9.08-10.65-15.42-13.32-4.73-2-10.19-.22-14.78,2.09s-9.13,5.22-14.26,5.55c-4.46.28-9.31-1.37-13.21.81-2.91,1.62-4.44,5-7.12,7s-6,2.35-9.3,2.53-6.62.21-9.59,1.56-5.41,4.49-4.8,7.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,72.82c.63-4.6-5.87-8.39-10.75-8.78-2.33-.19-4.75.17-6.95-.6-4.78-1.67-6.69-7.84-11.35-9.81-3.49-1.47-7.5-.16-10.88,1.54S194.3,59,190.53,59.26c-3.29.21-6.85-1-9.73.59-2.14,1.2-3.26,3.66-5.23,5.12s-4.45,1.73-6.85,1.86-4.87.15-7.06,1.15-4,3.3-3.53,5.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.76,176.68c.79-5.67-7.23-10.34-13.25-10.83-2.87-.23-5.85.21-8.57-.74-5.9-2.05-8.25-9.67-14-12.1-4.3-1.81-9.25-.19-13.42,1.9s-8.29,4.74-13,5c-4,.26-8.45-1.24-12,.74-2.64,1.47-4,4.51-6.46,6.31s-5.49,2.13-8.44,2.29-6,.19-8.71,1.42-4.91,4.08-4.35,7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.27,85.55s-.3-.08-.84-.19a6.74,6.74,0,0,0-2.31-.06A6.17,6.17,0,0,0,111,86.65a6.4,6.4,0,0,0-2.17,3.46v0l-.13.51-.2-.49a6.88,6.88,0,0,0-2.6-3.15,6.7,6.7,0,0,0-3.19-1.08,8.71,8.71,0,0,0-3.12.39,2.85,2.85,0,0,1,.79-.34,6.82,6.82,0,0,1,5.69.76A7,7,0,0,1,108.85,90l-.33,0v0a6.65,6.65,0,0,1,2.31-3.63,6.43,6.43,0,0,1,5.62-1.17A2.55,2.55,0,0,1,117.27,85.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.65,139.87a9.52,9.52,0,0,1-.76.89A19.2,19.2,0,0,0,173,143.3a18.62,18.62,0,0,0-2.78,9.88v.13l-.35,0a16.58,16.58,0,0,0-4.55-9.07,23.29,23.29,0,0,0-3.32-2.7l.27.13a7.06,7.06,0,0,1,.75.43,14.58,14.58,0,0,1,2.47,2,16.14,16.14,0,0,1,4.72,9.19l-.34,0v-.12a18.16,18.16,0,0,1,2.93-10,16.7,16.7,0,0,1,2-2.51c.25-.27.48-.46.62-.6A1.63,1.63,0,0,1,175.65,139.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,480.52a11.39,11.39,0,0,0-16.71-9.7,8.68,8.68,0,0,0-17.15,2.53,9.86,9.86,0,0,0-11.42,4.42,12.16,12.16,0,0,0-5.14-9.95,18.66,18.66,0,0,0-11-3.29c-2.54,0-5.23.41-7.21,2s-3,4.63-1.61,6.79a10.44,10.44,0,0,0-9.81,7.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,480.52a11.38,11.38,0,0,0-16.7-9.7,8.68,8.68,0,0,0-17.16,2.53,9.85,9.85,0,0,0-11.41,4.42,12.21,12.21,0,0,0-5.14-9.95,18.7,18.7,0,0,0-11-3.29,11.26,11.26,0,0,0-7.22,2c-2,1.59-3,4.63-1.6,6.79a10.43,10.43,0,0,0-9.81,7.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.31,480.52a11.39,11.39,0,0,0-16.7-9.7,8.68,8.68,0,0,0-17.16,2.53A9.85,9.85,0,0,0,352,477.77a12.21,12.21,0,0,0-5.14-9.95,18.7,18.7,0,0,0-11-3.29,11.26,11.26,0,0,0-7.22,2c-2,1.59-3,4.63-1.61,6.79a10.42,10.42,0,0,0-9.8,7.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.49,458.45a4.59,4.59,0,0,0-.72-2.18,2.11,2.11,0,0,0-.65-.68,1,1,0,0,0-.91-.08,1,1,0,0,0-.49.93,1.67,1.67,0,0,0,.47,1,3,3,0,0,0,2.3,1",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--hazardous-waste--inject-63"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 156.74,
    cy: 441.41,
    r: 9.58,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.6,441.46a21.57,21.57,0,0,0-.47-2.88,11.69,11.69,0,0,0-15.35-8,10.78,10.78,0,0,0-2.94,1.59,11,11,0,0,0-2.45,2.46,11.56,11.56,0,0,0,0,13.73,11.54,11.54,0,0,0,5.39,4.05,11.62,11.62,0,0,0,11-1.63,11.83,11.83,0,0,0,4.32-6.41,21.88,21.88,0,0,0,.47-2.87,3.4,3.4,0,0,1,0,.76,5.55,5.55,0,0,1-.07.92,8.6,8.6,0,0,1-.22,1.24,12,12,0,0,1-9.36,8.94,12.06,12.06,0,0,1-6.36-.49,12,12,0,0,1-5.63-4.21,12,12,0,0,1,0-14.33,11.15,11.15,0,0,1,2.57-2.56,11.34,11.34,0,0,1,3.06-1.64,12.17,12.17,0,0,1,6.36-.5,12,12,0,0,1,9.36,8.94,8.48,8.48,0,0,1,.22,1.25,5.47,5.47,0,0,1,.07.92A3.4,3.4,0,0,1,168.6,441.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.29,442.25a31.73,31.73,0,0,1,8.25-1.22,11.33,11.33,0,0,1,7.66,2.87c2.28,2.21,3.13,5.47,3.72,8.58,1.75,9.31,2,18.84,2,28.32H149.6l.14-32.91A7.74,7.74,0,0,1,147.29,442.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.36,
    cy: 441.41,
    r: 9.58,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.22,441.46a21.57,21.57,0,0,0-.47-2.88,11.69,11.69,0,0,0-15.35-8,10.78,10.78,0,0,0-2.94,1.59,11,11,0,0,0-2.45,2.46,11.56,11.56,0,0,0,0,13.73,10.84,10.84,0,0,0,2.45,2.47,11,11,0,0,0,2.94,1.58,11.6,11.6,0,0,0,11-1.63,11.8,11.8,0,0,0,4.33-6.41,21.88,21.88,0,0,0,.47-2.87,4,4,0,0,1,0,.76,4.53,4.53,0,0,1-.06.92,8.6,8.6,0,0,1-.22,1.24,12,12,0,0,1-9.36,8.94,12.06,12.06,0,0,1-6.36-.49,11.54,11.54,0,0,1-3.07-1.64,11.82,11.82,0,0,1-2.57-2.57,12,12,0,0,1,0-14.33,11.31,11.31,0,0,1,2.56-2.56,11.54,11.54,0,0,1,3.07-1.64,12.17,12.17,0,0,1,6.36-.5,12,12,0,0,1,5.06,2.29,11.82,11.82,0,0,1,4.3,6.65,8.48,8.48,0,0,1,.22,1.25,4.49,4.49,0,0,1,.06.92A4,4,0,0,1,264.22,441.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.91,442.25a31.73,31.73,0,0,1,8.25-1.22,11.33,11.33,0,0,1,7.66,2.87c2.28,2.21,3.13,5.47,3.72,8.58,1.75,9.31,2,18.84,2,28.32H245.22l.14-32.91A7.71,7.71,0,0,1,242.91,442.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.34,
    cy: 441.41,
    r: 9.58,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.2,441.46a21.57,21.57,0,0,0-.47-2.88,11.69,11.69,0,0,0-15.35-8,11.72,11.72,0,0,0-5.39,4,11.6,11.6,0,0,0,0,13.73,11,11,0,0,0,2.45,2.47,11.18,11.18,0,0,0,2.94,1.58,11.62,11.62,0,0,0,11-1.63,11.83,11.83,0,0,0,4.32-6.41,21.88,21.88,0,0,0,.47-2.87,3.4,3.4,0,0,1,0,.76,5.55,5.55,0,0,1-.07.92,8.6,8.6,0,0,1-.22,1.24,12,12,0,0,1-9.36,8.94,12,12,0,0,1-6.35-.49,11.25,11.25,0,0,1-3.07-1.64,11.39,11.39,0,0,1-2.57-2.57,12,12,0,0,1,0-14.33,12.18,12.18,0,0,1,5.64-4.2,12.12,12.12,0,0,1,6.35-.5,12,12,0,0,1,9.36,8.94,8.48,8.48,0,0,1,.22,1.25,5.47,5.47,0,0,1,.07.92A3.4,3.4,0,0,1,361.2,441.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.89,442.25a31.8,31.8,0,0,1,8.26-1.22,11.36,11.36,0,0,1,7.66,2.87c2.27,2.21,3.12,5.47,3.71,8.58,1.75,9.31,2,18.84,2,28.32H342.2l.15-32.91A7.75,7.75,0,0,1,339.89,442.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.91,480.8c0,.14-82.79.26-184.9.26s-184.92-.12-184.92-.26,82.77-.26,184.92-.26S434.91,480.65,434.91,480.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.63,471.25a111.94,111.94,0,0,1,0-15.25,111.94,111.94,0,0,1,0,15.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.93,475.55a98,98,0,0,1,0-14.27,94.41,94.41,0,0,1,0,14.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.58,472.22a59.79,59.79,0,0,1,0-11.14,59.79,59.79,0,0,1,0,11.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.12,480.82c-.14,0-.26-5.29-.26-11.82s.12-11.83.26-11.83.27,5.3.27,11.83S255.27,480.82,255.12,480.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.56,471.64a55.69,55.69,0,0,1,0-10.75,55.69,55.69,0,0,1,0,10.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.88,473.4a126.77,126.77,0,0,1,0-16.23,126.77,126.77,0,0,1,0,16.23Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Factory--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.36,256.93c-2.14-3.13,1.09-7.37,4.66-8.68s7.67-1.22,10.8-3.36c6.67-4.55,4.81-15.82,10.93-21.09,5.68-4.91,15.13-2,21.28-6.34,8.34-5.83,5.41-20.61,13.72-26.46,5.47-3.85,13-1.82,19.57-2.95,14.92-2.55,24.28-21.09,39.42-20.83,9.48.16,17.34,7.95,26.76,9.08,7.65.92,15.17-2.69,22.88-2.66,11.29,0,21.58,8.35,25.76,18.84s2.87,22.61-1.64,33c-3.61,8.27-9.3,15.76-16.83,20.73s-17,7.28-25.81,5.5c-5.92-1.19-11.34-4.1-17.07-6s-12.29-2.77-17.63,0-8.67,8.76-14.44,10.1c-4.86,1.12-9.71-1.43-14.24-3.51s-10.1-3.7-14.27-1c-2.31,1.51-3.68,4.06-5.47,6.17s-4.53,3.92-7.17,3.09",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.24,259.59s6.84,90.88-21.86,149h114.8s-30-73.55-23.18-150Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.72,264.83H81.87a4.34,4.34,0,0,1-4.34-4.33h0a4.34,4.34,0,0,1,4.34-4.34h71.85a4.34,4.34,0,0,1,4.34,4.34h0A4.33,4.33,0,0,1,153.72,264.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.53,
    y: 323.14,
    width: 82.49,
    height: 4.28,
    rx: 1.94,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.15,265.35c0,.15-15.33.26-34.24.26s-34.24-.11-34.24-.26,15.33-.26,34.24-.26S152.15,265.21,152.15,265.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.24,323.3c0,.15-16.15.26-36.07.26s-36.07-.11-36.07-.26,16.15-.26,36.07-.26S155.24,323.16,155.24,323.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.25,327.05c0,.14-16.92.26-37.79.26s-37.8-.12-37.8-.26,16.92-.26,37.8-.26S157.25,326.9,157.25,327.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.21,408.56c.1-6.34-5.4-16.53-11.66-20-4.86-2.67-14.55-4.44-19-1.19-1.08-8.69-9.86-15.66-18.57-14.74S57.1,382.2,57.85,390.92c-6.52-4.4-16.68-1.59-20,5.54,0,0-19.53-3.85-22.8,12.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.84,284s-6.37,1.39-6.24,10.52h8.57a3.94,3.94,0,0,1,1.48-3.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.29,294.63a12.7,12.7,0,0,0-5.63-10.9l-4.77,7.12a3.6,3.6,0,0,1,1.9,3.7Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.92,305.51a12.69,12.69,0,0,0,12.26.06L121.09,298a3.17,3.17,0,0,1-4.17,0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.3,294.44a2.21,2.21,0,1,1-2.21-2.21A2.21,2.21,0,0,1,121.3,294.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.21,115.58c-.63-9.17-7.45-17.86-16.46-19.73-13.85-2.88-27.95,9.62-41.47,5.42-5.32-1.65-9.89-5.8-15.46-6s-10.25,3.36-14,7.29-7,8.48-11.7,11.21c-7.49,4.36-17.92,3.7-23.49,10.35-6,7.15-2.74,18.63-7.69,26.53-3.33,5.32-12.08,7.93-15.76,13-3.19,4.41-3.32,10.91-4,16.31-1.33,10.91-.13,24.5-1.45,35.4l3.09-.25c-.24-4-.48-8,.41-11.83s3.1-7.61,6.62-9.43c5.3-2.73,12.57-.74,17-4.76,5.12-4.69,2.39-13.84,6.62-19.35,4-5.22,12-4.62,18.31-2.83s13.36,4.2,19.16,1.1c8.86-4.74,8.38-18.81,16.75-24.37,7.18-4.78,16.62-.9,25.12.6,9.06,1.59,18.83.07,26.4-5.14S400.84,124.76,400.21,115.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.32,85.41c-1.09-5.87-4.65-11.83-13.9-12.19A14.68,14.68,0,0,0,270.51,99a14.51,14.51,0,0,0,23.81-13.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.18,
    y: 277.59,
    width: 96.68,
    height: 130.5,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.86,408.09s0-.22,0-.63,0-1,0-1.84c0-1.62,0-4,0-7.11,0-6.21,0-15.28-.07-26.77,0-22.95-.07-55.55-.11-94.15l.23.23-96.67,0h0l.26-.26c0,48.67,0,93.77-.05,130.5l-.21-.22,70.24.11L407,408l5.14,0,1.77,0-1.73,0-5.09,0-19.48.06-70.38.11H317v-.21c0-36.73,0-81.83-.05-130.5v-.27h.27l96.67,0h.24v.24c-.05,38.67-.09,71.31-.12,94.31,0,11.46-.05,20.51-.06,26.71q0,4.63,0,7.07c0,.79,0,1.39,0,1.8S413.86,408.09,413.86,408.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.22,406.85c-.14,0-.26-27.84-.26-62.17s.12-62.17.26-62.17.26,27.83.26,62.17S342.36,406.85,342.22,406.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.07,53.21c-2.27-7.91-10.75-13.86-18.83-12.28-4.24.83-8.14,3.49-12.46,3.34-3.51-.12-6.65-2.09-10-3.16A20.36,20.36,0,0,0,401.34,49c-2.68,4-4.19,9.31-8.55,11.4-3.49,1.67-8,.75-11.09,3.06-3.79,2.83-3.31,8.65-5.65,12.76A31.07,31.07,0,0,1,370.17,83c-2.74,2.63-2.21,9.52-2,12.23h6c.12-3.28,3-7.45,6.21-8.2s6.54-.06,9.74.67,6.51,1.49,9.74.92c6-1.06,10.31-6.4,16.11-8.16s12.23.41,18.39,1.13c8.18,1,16.89-1,23.19-6.24S467.34,61.13,465.07,53.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.48 408.56 301.37 349.87 323.77 341.11 345.57 349.87 345.79 408.56 301.48 408.56",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.57,349.87c0,.15-9.89.26-22.1.26s-22.1-.11-22.1-.26,9.89-.26,22.1-.26S345.57,349.73,345.57,349.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.71,408c-.14,0-.26-12.91-.26-28.84s.12-28.83.26-28.83.26,12.9.26,28.83S322.85,408,322.71,408Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.71,
    y: 294.39,
    width: 61.15,
    height: 8.76,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.82,303.15a39.51,39.51,0,0,1,0-9,39.51,39.51,0,0,1,0,9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.48,303.15a39.51,39.51,0,0,1,0-9,39.51,39.51,0,0,1,0,9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.14,303.15a39.51,39.51,0,0,1,0-9,39.51,39.51,0,0,1,0,9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.8,303.15a39.51,39.51,0,0,1,0-9,39.51,39.51,0,0,1,0,9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.46,303.15a39.51,39.51,0,0,1,0-9,39.51,39.51,0,0,1,0,9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.71,
    y: 313.84,
    width: 61.15,
    height: 8.76,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.82,322.6a39.51,39.51,0,0,1,0-9.05,39.51,39.51,0,0,1,0,9.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.48,322.6a39.51,39.51,0,0,1,0-9.05,39.51,39.51,0,0,1,0,9.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.14,322.6a39.51,39.51,0,0,1,0-9.05,39.51,39.51,0,0,1,0,9.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.8,322.6a39.51,39.51,0,0,1,0-9.05,39.51,39.51,0,0,1,0,9.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.46,322.6a39.51,39.51,0,0,1,0-9.05,39.51,39.51,0,0,1,0,9.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.71,
    y: 332.82,
    width: 61.15,
    height: 8.76,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.82,341.58a39.51,39.51,0,0,1,0-9.05,39.51,39.51,0,0,1,0,9.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.48,341.58a39.51,39.51,0,0,1,0-9.05,39.51,39.51,0,0,1,0,9.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.14,341.58a39.51,39.51,0,0,1,0-9.05,39.51,39.51,0,0,1,0,9.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.8,341.58a39.51,39.51,0,0,1,0-9.05,39.51,39.51,0,0,1,0,9.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.46,341.58a39.51,39.51,0,0,1,0-9.05,39.51,39.51,0,0,1,0,9.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.71,
    y: 351.79,
    width: 61.15,
    height: 8.76,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.82,360.55a39.42,39.42,0,0,1,0-9,39.42,39.42,0,0,1,0,9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.48,360.55a39.42,39.42,0,0,1,0-9,39.42,39.42,0,0,1,0,9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.14,360.55a39.42,39.42,0,0,1,0-9,39.42,39.42,0,0,1,0,9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.8,360.55a39.42,39.42,0,0,1,0-9,39.42,39.42,0,0,1,0,9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.46,360.55a39.42,39.42,0,0,1,0-9,39.42,39.42,0,0,1,0,9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.71,
    y: 371.57,
    width: 61.15,
    height: 8.76,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.82,380.33a39.51,39.51,0,0,1,0-9.05,39.51,39.51,0,0,1,0,9.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.48,380.33a39.51,39.51,0,0,1,0-9.05,39.51,39.51,0,0,1,0,9.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.14,380.33a39.51,39.51,0,0,1,0-9.05,39.51,39.51,0,0,1,0,9.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.8,380.33a39.51,39.51,0,0,1,0-9.05,39.51,39.51,0,0,1,0,9.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.46,380.33a39.51,39.51,0,0,1,0-9.05,39.51,39.51,0,0,1,0,9.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.44,
    y: 273.78,
    width: 104.16,
    height: 7.61,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.6,281.39s0-.17,0-.5,0-.82,0-1.45c0-1.29,0-3.18-.05-5.66l.09.09c-15.76.1-56.48.17-104.15.17h0l.26-.26v7.61l-.26-.26,73.84.11,22.18.08,6,0h1.57l.55,0-.51,0-1.54,0-6,0-22.12.08-74,.11h-.26v-8.13h.27c47.67,0,88.39.07,104.15.17h.1v.09c0,2.51,0,4.41-.05,5.72,0,.61,0,1.09,0,1.42S417.6,281.39,417.6,281.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.55 103.47 380.29 91.83 379.6 91.83 363.45 91.83 362.25 91.83 360.5 103.47 363.45 103.47 363.45 273.78 379.6 273.78 379.6 103.47 382.55 103.47",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.55,
    y: 103.6,
    width: 16.15,
    height: 32.91,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.55,
    y: 170.19,
    width: 16.15,
    height: 32.91,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.55,
    y: 240.86,
    width: 16.15,
    height: 32.91,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.55,103.47l-.68,0-2.27,0,0,0c.11,13.53.2,82.7.22,170.31V274H363.19V261c0-64.24.07-121.47.1-157.56l.16.16h-3.14l0-.18c.66-4.3,1.24-8.13,1.78-11.64V91.7h.12l18,0h.07v.07l1.66,8.79c.17,1,.31,1.67.4,2.16l.12.7s-.06-.25-.16-.73-.24-1.21-.44-2.17l-1.75-8.72.09.07-18,0,.13-.12c-.52,3.52-1.09,7.34-1.73,11.65l-.15-.18h3.11v.16c0,36.09.06,93.32.1,157.56v12.75l-.26-.26H379.6l-.26.26c0-87.61.11-156.78.22-170.31v0h0l2.24,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.09,103.6c0,.14-4.69.26-10.46.26s-10.46-.12-10.46-.26a101.19,101.19,0,0,1,10.46-.27A101.35,101.35,0,0,1,382.09,103.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,111.43c-5-5.11-13.56-6.77-19.73-3.11-4.4,2.61-7.32,7.48-12.1,9.28-5,1.88-10.79,0-15.75,1.87-8.09,3.14-9.22,13.76-12,22-2.12,6.31-6.69,9.94-7.74,16.51-3,18.83-3.1,48.87-1.36,70.12h4.51a95.45,95.45,0,0,1-.19-24c1-7.57,5.42-15.18,12.59-17.82,4.95-1.83,10.42-1.09,15.7-1s11.14-.89,14.47-5c5-6.12,1.77-15.77,5.68-22.62,2.11-3.71,6-6,9.32-8.66,5.61-4.47,10.12-10.58,11.71-17.58S261,116.53,256,111.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.3 227.42 196.87 220.06 196.44 220.06 186.22 220.06 185.46 220.06 184.35 227.42 186.22 227.42 186.22 335.12 196.44 335.12 196.44 227.42 198.3 227.42",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.29,
    y: 227.49,
    width: 10.21,
    height: 20.81,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.29,
    y: 269.61,
    width: 10.21,
    height: 20.81,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.29,
    y: 314.3,
    width: 10.21,
    height: 20.81,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.3,227.42h-.43l-1.44,0,0,0c.11,8.55.2,52.29.21,107.69v.26H186v-8.32c0-40.61.08-76.8.1-99.63l.16.16h-2.05l0-.18c.42-2.72.79-5.13,1.13-7.35l0-.12h.11l11.41.05h.07V220l1,5.57.25,1.37c.05.29.07.44.07.44s0-.16-.11-.47-.16-.78-.28-1.38c-.25-1.23-.63-3-1.12-5.5l.08.07-11.41.05.14-.11c-.33,2.22-.69,4.64-1.09,7.36l-.16-.18h2v.17c0,22.83.06,59,.1,99.63v8.06l-.26-.26h10.21l-.25.25c0-55.4.1-99.14.21-107.69v0h0l1.42,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,227.49a41.41,41.41,0,0,1-6.62.26,41.33,41.33,0,0,1-6.61-.26,42.78,42.78,0,0,1,6.61-.26A42.86,42.86,0,0,1,198,227.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.32 277.58 205.06 282.61 205.06 335.63 209.32 335.63 209.32 277.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.37 277.58 215.1 282.61 215.1 335.63 219.37 335.63 219.37 277.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.41 277.58 225.14 282.61 225.14 335.63 229.41 335.63 229.41 277.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.74,
    y: 332.92,
    width: 140.78,
    height: 75.8,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.74,
    y: 332.8,
    width: 39.93,
    height: 75.8,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.08 332.92 245.92 332.92 246.05 213.63 254.21 213.63 254.08 332.92",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.2,217h-7.95a1.71,1.71,0,0,1-1.7-1.71h0a1.7,1.7,0,0,1,1.7-1.7h7.95a1.7,1.7,0,0,1,1.7,1.7h0A1.71,1.71,0,0,1,254.2,217Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.2,240.45h-7.95a1.7,1.7,0,0,1-1.7-1.7h0a1.7,1.7,0,0,1,1.7-1.7h7.95a1.7,1.7,0,0,1,1.7,1.7h0A1.7,1.7,0,0,1,254.2,240.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.2,263.87h-7.95a1.7,1.7,0,0,1-1.7-1.7h0a1.7,1.7,0,0,1,1.7-1.71h7.95a1.7,1.7,0,0,1,1.7,1.71h0A1.7,1.7,0,0,1,254.2,263.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.2,287.29h-7.95a1.71,1.71,0,0,1-1.7-1.71h0a1.7,1.7,0,0,1,1.7-1.7h7.95a1.7,1.7,0,0,1,1.7,1.7h0A1.71,1.71,0,0,1,254.2,287.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.2,310.7h-7.95a1.7,1.7,0,0,1-1.7-1.7h0a1.71,1.71,0,0,1,1.7-1.71h7.95a1.71,1.71,0,0,1,1.7,1.71h0A1.7,1.7,0,0,1,254.2,310.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.68,217.17a34.7,34.7,0,0,1-8.48,0,34.7,34.7,0,0,1,8.48,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.68,237.14a33.43,33.43,0,0,1-8.48,0,34.7,34.7,0,0,1,8.48,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.68,240.73a34.7,34.7,0,0,1-8.48,0,34.7,34.7,0,0,1,8.48,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.68,260.5a34.7,34.7,0,0,1-8.48,0,33.43,33.43,0,0,1,8.48,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.68,264.09a34.7,34.7,0,0,1-8.48,0,33.43,33.43,0,0,1,8.48,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.68,284a34.7,34.7,0,0,1-8.48,0,34.7,34.7,0,0,1,8.48,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.68,287.62a34.7,34.7,0,0,1-8.48,0,34.7,34.7,0,0,1,8.48,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.68,307.57a34.7,34.7,0,0,1-8.48,0,34.7,34.7,0,0,1,8.48,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.68,311.16a34.7,34.7,0,0,1-8.48,0,34.7,34.7,0,0,1,8.48,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.74,408.56l.69,0h2l7.77,0,29.12-.07,101.19-.12-.24.25c0-23.39,0-49,0-75.8h0l.26.26L144.74,333l.2-.2c0,23.3-.08,42.23-.1,55.34,0,6.56,0,11.67-.05,15.15,0,1.73,0,3.05,0,3.95s0,1.37,0,1.37,0-.44,0-1.33,0-2.2,0-3.92c0-3.46,0-8.55,0-15.1,0-13.14-.06-32.11-.1-55.46v-.19h.19l140.78-.07h.26v.26h0c0,26.78,0,52.41,0,75.8v.24h-.25l-101.35-.12-29.07-.06-7.71,0-2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.58,
    y: 341.95,
    width: 4.78,
    height: 8.76,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.22,
    y: 341.95,
    width: 70.86,
    height: 8.76,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.22,
    y: 361.14,
    width: 70.86,
    height: 8.76,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.58,
    y: 361.14,
    width: 4.78,
    height: 8.76,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.07,
    y: 380.33,
    width: 4.78,
    height: 8.76,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.22,
    y: 380.33,
    width: 4.78,
    height: 8.76,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.76,
    y: 373.39,
    width: 93.42,
    height: 34.99,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.18,408.38s0-.22,0-.63,0-1,0-1.81c0-1.6,0-3.93,0-6.94,0-6-.06-14.75-.1-25.61l.18.17-93.42.09h0l.26-.26c0,12.21,0,24,0,35l-.25-.25,66.89.12,19.47.07,5.23,0h1.36l.47,0-.44,0h-1.33l-5.17,0-19.42.07-67.06.12h-.25v-.25c0-11,0-22.78,0-35v-.26h.26l93.42.08h.18v.18c0,10.9-.08,19.67-.1,25.72,0,3,0,5.31,0,6.9,0,.77,0,1.36,0,1.78S317.18,408.38,317.18,408.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.2,408.38c-.15,0-.26-7.83-.26-17.5s.11-17.49.26-17.49.26,7.83.26,17.49S249.34,408.38,249.2,408.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.65,
    y: 379.75,
    width: 2.71,
    height: 15.28,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.51,
    y: 379.75,
    width: 2.71,
    height: 15.28,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.37,
    y: 379.75,
    width: 2.71,
    height: 15.28,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.22,
    y: 379.75,
    width: 2.71,
    height: 15.28,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.08,
    y: 379.75,
    width: 2.71,
    height: 15.28,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.94,
    y: 379.75,
    width: 2.71,
    height: 15.28,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.35,408.73c-.14,0-.26-16.93-.26-37.8s.12-37.81.26-37.81.26,16.93.26,37.81S184.5,408.73,184.35,408.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.42,408.57v-28a8.22,8.22,0,0,1,8.21-8.21h5.59a3,3,0,1,1,0,6h-5.59a2.21,2.21,0,0,0-2.21,2.21v28",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.84,408.6v-28a8.21,8.21,0,0,1,8.21-8.2h5.59a3,3,0,0,1,0,6h-5.59a2.2,2.2,0,0,0-2.21,2.2v28",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.22,372.44a2,2,0,0,1,1.62-.36,3.29,3.29,0,0,1,1.72.72,3.24,3.24,0,0,1,1.11,2,3.15,3.15,0,0,1-1.88,3.44c-1,.42-1.68.2-1.65.15a7.42,7.42,0,0,0,1.49-.48,3.1,3.1,0,0,0,1.17-1.12,2.84,2.84,0,0,0,.35-1.91,2.89,2.89,0,0,0-.91-1.71,3.14,3.14,0,0,0-1.45-.72A6.62,6.62,0,0,0,173.22,372.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.45,372.44a2,2,0,0,1,1.62-.36,3.29,3.29,0,0,1,1.72.72,3.24,3.24,0,0,1,1.11,2,3.15,3.15,0,0,1-1.88,3.44,2,2,0,0,1-1.66.15,7.18,7.18,0,0,0,1.5-.48,3.1,3.1,0,0,0,1.17-1.12,2.84,2.84,0,0,0,.35-1.91,2.89,2.89,0,0,0-.91-1.71,3.14,3.14,0,0,0-1.45-.72A6.62,6.62,0,0,0,155.45,372.44Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.27,414.05c0,.14-93.25.26-208.26.26s-208.28-.12-208.28-.26,93.23-.26,208.28-.26S458.27,413.9,458.27,414.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.27,408.56c0,.14-93.25.26-208.26.26s-208.28-.12-208.28-.26S135,408.3,250,408.3,458.27,408.41,458.27,408.56Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Birds--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.78,127.41s-.6-.21-1.7-.46a13.69,13.69,0,0,0-4.75-.18,12.9,12.9,0,0,0-6.41,2.76,13.33,13.33,0,0,0-4.52,7.18l0,.08-.13.51-.2-.48a14.29,14.29,0,0,0-5.41-6.54,13.73,13.73,0,0,0-6.61-2.2,14.7,14.7,0,0,0-4.72.43c-1.09.29-1.67.54-1.68.51a2.2,2.2,0,0,1,.41-.2,10.43,10.43,0,0,1,1.23-.44A14.09,14.09,0,0,1,117.81,130a14.47,14.47,0,0,1,5.56,6.68l-.33,0,0-.08a13.44,13.44,0,0,1,4.65-7.34,12.9,12.9,0,0,1,6.57-2.76,13.11,13.11,0,0,1,4.82.29,10.45,10.45,0,0,1,1.25.4C140.64,127.33,140.79,127.39,140.78,127.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.3,101.33s-.34-.09-.94-.22a7.62,7.62,0,0,0-2.6-.07,7,7,0,0,0-3.49,1.52,7.21,7.21,0,0,0-2.45,3.91v0l-.14.51-.19-.48a7.84,7.84,0,0,0-2.95-3.57,7.55,7.55,0,0,0-3.6-1.21,7.88,7.88,0,0,0-2.58.21c-.6.15-.92.28-.93.25s.07-.06.22-.13a4.47,4.47,0,0,1,.67-.25,7.69,7.69,0,0,1,6.4.87,8,8,0,0,1,3.09,3.7l-.33,0v0a7.46,7.46,0,0,1,2.59-4.08,7.12,7.12,0,0,1,3.65-1.52,7.44,7.44,0,0,1,2.67.19,5.76,5.76,0,0,1,.68.23A.82.82,0,0,1,188.3,101.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.23,90.66s-.32.37-.91,1a22.2,22.2,0,0,0-5.54,14.72v.15l-.35,0a19.57,19.57,0,0,0-2.14-6.35,20,20,0,0,0-6.09-6.8c-.72-.5-1.14-.75-1.13-.78a1.16,1.16,0,0,1,.32.15,9.59,9.59,0,0,1,.88.52,17.78,17.78,0,0,1,2.93,2.33,19.51,19.51,0,0,1,3.37,4.43,19.19,19.19,0,0,1,2.2,6.45l-.34,0v-.15a21.58,21.58,0,0,1,3.45-11.85,20.08,20.08,0,0,1,2.34-3c.3-.33.57-.55.74-.71S157.22,90.65,157.23,90.66Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAidaCardImg);
export default __webpack_public_path__ + "static/media/aida-cardImg.8f54e7f35e424c6df6ad2ea2b1cfdc69.svg";
export { ForwardRef as ReactComponent };